import { jsx as s, jsxs as P } from "react/jsx-runtime";
import * as d from "react";
import { forwardRef as w, useId as U } from "react";
import { a as z, c as y } from "../index-eoE_jzLb.js";
import { u as N } from "../index-DoOsnuB6.js";
import { P as _, c as E } from "../index-D8UDu4KA.js";
import { R as B, I as H, c as g } from "../index-ClOoRiow.js";
import { u as $ } from "../index-Dn75bnUs.js";
import { u as W } from "../index-4vbonZJj.js";
import { u as X } from "../index-BZPx6jYI.js";
import { P as Y } from "../index-CRtCLpV2.js";
import { c as I } from "../clsx-OuTLNxxd.js";
import { L as J } from "../Label-B9Ttm_DE.js";
import '../RadioGroup.css';var k = "Radio", [Q, S] = E(k), [Z, ee] = Q(k), A = d.forwardRef(
  (r, a) => {
    const {
      __scopeRadio: e,
      name: n,
      checked: o = !1,
      required: t,
      disabled: i,
      value: l = "on",
      onCheck: u,
      form: m,
      ...v
    } = r, [p, f] = d.useState(null), c = N(a, (b) => f(b)), R = d.useRef(!1), h = p ? m || !!p.closest("form") : !0;
    return /* @__PURE__ */ P(Z, { scope: e, checked: o, disabled: i, children: [
      /* @__PURE__ */ s(
        _.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": L(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...v,
          ref: c,
          onClick: y(r.onClick, (b) => {
            o || u == null || u(), h && (R.current = b.isPropagationStopped(), R.current || b.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ s(
        oe,
        {
          control: p,
          bubbles: !R.current,
          name: n,
          value: l,
          checked: o,
          required: t,
          disabled: i,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
A.displayName = k;
var x = "RadioIndicator", D = d.forwardRef(
  (r, a) => {
    const { __scopeRadio: e, forceMount: n, ...o } = r, t = ee(x, e);
    return /* @__PURE__ */ s(Y, { present: n || t.checked, children: /* @__PURE__ */ s(
      _.span,
      {
        "data-state": L(t.checked),
        "data-disabled": t.disabled ? "" : void 0,
        ...o,
        ref: a
      }
    ) });
  }
);
D.displayName = x;
var oe = (r) => {
  const { control: a, checked: e, bubbles: n = !0, ...o } = r, t = d.useRef(null), i = X(e), l = W(a);
  return d.useEffect(() => {
    const u = t.current, m = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(m, "checked").set;
    if (i !== e && p) {
      const f = new Event("click", { bubbles: n });
      p.call(u, e), u.dispatchEvent(f);
    }
  }, [i, e, n]), /* @__PURE__ */ s(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: e,
      ...o,
      tabIndex: -1,
      ref: t,
      style: {
        ...r.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function L(r) {
  return r ? "checked" : "unchecked";
}
var re = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], C = "RadioGroup", [te] = E(C, [
  g,
  S
]), M = g(), O = S(), [ae, ne] = te(C), F = d.forwardRef(
  (r, a) => {
    const {
      __scopeRadioGroup: e,
      name: n,
      defaultValue: o,
      value: t,
      required: i = !1,
      disabled: l = !1,
      orientation: u,
      dir: m,
      loop: v = !0,
      onValueChange: p,
      ...f
    } = r, c = M(e), R = $(m), [h, b] = z({
      prop: t,
      defaultProp: o,
      onChange: p
    });
    return /* @__PURE__ */ s(
      ae,
      {
        scope: e,
        name: n,
        required: i,
        disabled: l,
        value: h,
        onValueChange: b,
        children: /* @__PURE__ */ s(
          B,
          {
            asChild: !0,
            ...c,
            orientation: u,
            dir: R,
            loop: v,
            children: /* @__PURE__ */ s(
              _.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": u,
                "data-disabled": l ? "" : void 0,
                dir: R,
                ...f,
                ref: a
              }
            )
          }
        )
      }
    );
  }
);
F.displayName = C;
var q = "RadioGroupItem", K = d.forwardRef(
  (r, a) => {
    const { __scopeRadioGroup: e, disabled: n, ...o } = r, t = ne(q, e), i = t.disabled || n, l = M(e), u = O(e), m = d.useRef(null), v = N(a, m), p = t.value === o.value, f = d.useRef(!1);
    return d.useEffect(() => {
      const c = (h) => {
        re.includes(h.key) && (f.current = !0);
      }, R = () => f.current = !1;
      return document.addEventListener("keydown", c), document.addEventListener("keyup", R), () => {
        document.removeEventListener("keydown", c), document.removeEventListener("keyup", R);
      };
    }, []), /* @__PURE__ */ s(
      H,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: p,
        children: /* @__PURE__ */ s(
          A,
          {
            disabled: i,
            required: t.required,
            checked: p,
            ...u,
            ...o,
            name: t.name,
            ref: v,
            onCheck: () => t.onValueChange(o.value),
            onKeyDown: y((c) => {
              c.key === "Enter" && c.preventDefault();
            }),
            onFocus: y(o.onFocus, () => {
              var c;
              f.current && ((c = m.current) == null || c.click());
            })
          }
        )
      }
    );
  }
);
K.displayName = q;
var se = "RadioGroupIndicator", V = d.forwardRef(
  (r, a) => {
    const { __scopeRadioGroup: e, ...n } = r, o = O(e);
    return /* @__PURE__ */ s(D, { ...o, ...n, ref: a });
  }
);
V.displayName = se;
var T = F, j = K, ie = V;
const ce = "_radioGroupRoot_649h2_32", de = "_radioGroupItem_649h2_37", ue = "_radioGroupIndicator_649h2_49", pe = "_label_649h2_66", G = {
  radioGroupRoot: ce,
  radioGroupItem: de,
  radioGroupIndicator: ue,
  label: pe
}, le = w(({ className: r, ...a }, e) => /* @__PURE__ */ s(
  T,
  {
    className: I(G.radioGroupRoot, r),
    "data-cxy-name": "radio-group",
    ...a,
    ref: e
  }
));
le.displayName = T.displayName;
const me = w(({ children: r, className: a, ...e }, n) => {
  const o = U();
  return /* @__PURE__ */ P(J, { className: I(G.label, { [G.checked]: e.checked }), id: o, children: [
    /* @__PURE__ */ s(
      j,
      {
        "aria-labelledby": o,
        className: I(G.radioGroupItem, a),
        ref: n,
        ...e,
        children: /* @__PURE__ */ s(ie, { className: G.radioGroupIndicator })
      }
    ),
    r
  ] });
});
me.displayName = j.displayName;
export {
  le as RadioGroup,
  me as RadioGroupItem
};
